import { EmailOnboardingActionTypes } from './emailOnboardingTypes';

export const startNylasUser = (payload: any) => ({
	type: EmailOnboardingActionTypes.EMAIL_ONBOARDING_NYLAS_SIGNUP_REQUEST,
	payload
});

export const startNylasUserCalendar = (payload: any) => ({
	type: EmailOnboardingActionTypes.EMAIL_ONBOARDING_NYLAS_CALENDAR_SIGNUP_REQUEST,
	payload
});
